import { useEffect, useState } from 'react'

import { fetchCertificatePdf } from '../utils/certificatePdf'

type CertificatePreview = { status: 'idle' | 'loading' | 'error'; blob?: undefined } | { status: 'ready'; blob: Blob }

/**
 * Fetches a certificate for the preview modal and holds the bytes.
 *
 * The blob is kept in state rather than rebuilt per render because react-pdf reloads the document
 * whenever the `file` prop changes identity. Only fetches while the modal is open.
 */
export const useCertificatePreview = (url: string | undefined, open: boolean): CertificatePreview => {
  const [preview, setPreview] = useState<CertificatePreview>({ status: 'idle' })

  useEffect(() => {
    if (!open || !url) {
      setPreview({ status: 'idle' })
      return
    }

    let cancelled = false
    setPreview({ status: 'loading' })

    fetchCertificatePdf(url)
      .then((blob) => {
        if (!cancelled) setPreview({ status: 'ready', blob })
      })
      .catch(() => {
        if (!cancelled) setPreview({ status: 'error' })
      })

    return () => {
      cancelled = true
    }
  }, [url, open])

  return preview
}
